/*
 * useStornoGui.tsx - Stornieren von Aufträgen.
 *
 * Created by Dr. Maximillian Dornseif 2023-11-07 in huWaWi3 33.5.1
 * Copyright (c) 2020, 2023 HUDORA GmbH
 */

import { IContextualMenuItemStyles, getTheme } from '@fluentui/react'
import gql from 'graphql-tag'
import { useConfirm } from 'material-ui-confirm'
import * as React from 'react'
import toast from 'react-hot-toast'
import { AnyVariables, OperationResult, useMutation } from 'urql'

import { AUFTRAG_FRAGMENT } from '../../fragments'
import { ICommandBarItemProps } from '../../lib/muipanels'

export function useStornierenGui(auftrag) {
  const theme = getTheme()
  const [disabled, setDisabled] = React.useState(false)
  const [, mutateEntity] = useMutation(STORNO_MUTATION)
  const confirm = useConfirm()

  // Styles for both command bar and overflow/menu items
  const importantItemStyle: Partial<IContextualMenuItemStyles> = {
    icon: { color: theme.palette.red },
    iconHovered: { color: theme.palette.redDark },
  }

  const update = () => {
    setDisabled(true)
    confirm({
      description: 'Ein Storno kann nicht rückgängig gemacht werden.',
      confirmationText: 'Stornieren',
      confirmationButtonProps: { variant: 'contained', color: 'warning' },
    })
      .then(() => {
        const prom = async () => {
          const r = await mutateEntity({
            key: auftrag._keyStr,
            message: '',
          } as any)
          if (r.error) throw r.error
          return r
        }
        toast.promise(prom(), {
          loading: 'Stornieren',
          success: (r: OperationResult<any, AnyVariables>) => {
            setDisabled(false)
            return <React.Fragment>Erfolgreich storniert.</React.Fragment>
          },
          error: (e) => {
            setDisabled(false)
            console.error(e)
            return `Fehler: ${e}`
          },
        })
      })
      .catch(() => {
        setDisabled(false)
      })
  }

  const item: ICommandBarItemProps = {
    key: 'stornieren',
    text: 'Stornieren',
    title: 'Stornieren',
    ariaLabel: 'Stornieren',
    //   iconProps: { iconName: 'Delete' },
    //   disabled: false,
    //   // onClick: () => openPanel(),
    // },
    iconOnly: false,
    iconProps: { iconName: 'Delete' },
    buttonStyles: importantItemStyle,
    disabled: disabled || !(auftrag.status >= '100ready' && auftrag.status < '400'),
    onClick: () => update(),
  }
  return [item]
}

const STORNO_MUTATION = gql`
  mutation StornierenMutation($key: ID!, $message: String) {
    updateHwAuftragStornieren(key: $key, message: $message) {
      auftrag {
        ...auftragFragment
      }
      success
      message
    }
  }
  ${AUFTRAG_FRAGMENT}
`
